import AddTemplateModalController from './controllers/add-template-modal-controller';
import addTemplateModalTemplate from './views/add-template-modal.tpl.html';

export default class AlGuestlistTemplatesController {

    constructor($injector, $scope) {
        this.injector = $injector;
        this.scope = $scope;
        this.translate = this.injector.get('$translate');
        this.navService = this.injector.get('NavService');
        this.acl = this.injector.get('Acl');
        this.api = this.injector.get('$http');
        this.angularState = this.injector.get('$state');
        this.depositService = this.injector.get('Deposit');
        this.alert = this.injector.get('Alert');
        this.users = this.injector.get('Users');
        this.deposit = this.injector.get('Deposit');
        this.window = this.injector.get('$window');

        this.currentOpenTemplate = null;

        this.editorCancelTrigger = null;
        this.templatesStore = null;
        this.rsvpStates = {};
        this.rawTemplates = [];
        this.loading = true;

        this.availableTemplateTypes = _.get(this.users.state, 'company.settings.templates.available_template_types', {});
        this.availableTemplateStates = [];

        this._resetState();
        this._loadDeposits();
    }

    $onInit() {
        this._initWatchers();
    }

    // Public callable functions
    toggleTemplate(template) {
        const oldOpenTemplate = this.currentOpenTemplate;
        if (this.currentOpenTemplate) {
            this.closeTemplate(this.currentOpenTemplate, false, false)
                .then(() => {
                    if (template.id !== oldOpenTemplate) {
                        this.currentOpenTemplate = template.id;
                    }
                })
                .catch((e) => {

                })
        } else {
            this.currentOpenTemplate = template.id;
        }
    }

    handleTemplateSave(template) {
        this.closeTemplate(template.id, true, true);
        this._prepareAvailableTemplateStates();
    }

    closeTemplate(templateId, reload, force) {
        return new Promise((resolve, reject) => {
            if (this.currentOpenTemplate === templateId) {
                if (!force && this.editorCancelTrigger) {
                    this.editorCancelTrigger()
                        .then(() => {
                            resolve();
                        })
                        .catch(() => {
                            reject();
                        });
                    return;
                }

                resolve();
            }
        }).then(() => {
            this.editorCancelTrigger = null;
            this.currentOpenTemplate = null;

            if (reload) {
                this._loadTemplates();
            }
            this.scope.$applyAsync();
        })
    }

    deleteTemplateFromGuestlist(row) {
        const alertType = row.template.global_template ? 'ask-for-remove-relation' : 'ask-for-archive';

        this.alert.animatedAlert(
            this.translate.instant(`guestlists.components.al-guestlist-templates.alerts.${alertType}.title`),
            this.translate.instant(`guestlists.components.al-guestlist-templates.alerts.${alertType}.content`),
            "attention",
            {
                confirmButtonText: this.translate.instant('general.verbs.yes'),
                cancelButtonText: this.translate.instant('general.buttons.cancel'),
            }
        ).then(() => {
            return this.api.delete(`guestlists/${this.guestlist.id}/templates/${row.id}`).then(response => {
                this._loadTemplates().then(() => {
                    this.alert.info(
                        this.translate.instant('guestlists.components.al-guestlist-templates.alerts.archived.title'),
                        this.translate.instant('guestlists.components.al-guestlist-templates.alerts.archived.content')
                    );
                });
            }, err => this.alert.handle(err));
        }, err => this.alert.handle(err));
    }

    addTemplate(status) {
        status = status || '';

        const preCheckPromise = new Promise((resolve, reject) => {
            if (this.currentOpenTemplate) {
                this.closeTemplate(this.currentOpenTemplate, false, false)
                    .then(() => {
                        resolve();
                    }, () => {
                        reject();
                    })
                return;
            }

            resolve();
        })


        return preCheckPromise.then(() => {
            return this.injector.get('$uibModal').open({
                controller: AddTemplateModalController,
                controllerAs: 'vm',
                templateUrl: addTemplateModalTemplate,
                resolve: {
                    guestlist: () => {
                        return this.guestlist;
                    },
                    statusToLink: () => {
                        return status;
                    },
                    fullStates: () => {
                        return this.rsvpStates;
                    },
                    currentTemplates: () => {
                        return this.rawTemplates;
                    }
                }
            }).result.then(({guestlistTemplate}) => {
                this.window.scrollTo(0, 0);
                this._loadTemplates()
                    .then(() => {
                        this.currentOpenTemplate = guestlistTemplate.id;
                    });
            }, () => {
                this._loadTemplates();
            })
        });
    }

    // Private callable functions
    _initWatchers() {
        this.scope.$watch(() => {
            return this.guestlist;
        }, (newVal, oldVal) => {
            if (this.guestlist
                && (
                    !this.templatesStore
                    || _.get(newVal, 'id') !== _.get(oldVal, 'id')
                )
            ) {
                this._prepareTemplatesStore();
                this._updateActions();
            }
        });
    }

    _updateState(newState) {
        this.state = newState;
        this.scope.$applyAsync();
    }

    _resetState() {
        this._updateState({
            currentTemplates: []
        });
    }

    _prepareTemplatesStore() {
        this.templatesStore = this.injector.get('GuestlistTemplates').reset({
            persist: false,
            listview: `Guestlist${this.guestlist.id}Templates`,
            slug: `guestlists/${this.guestlist.id}/templates`,
            visible: [
                'template.id',
                'template.name',
                'template.subject',
                'template.template_type',
                'template.global_template',
                'template.deleted_at',
                'status'
            ],
            sort: {
                created_at: 'desc'
            }
        });

        this.templatesStore.dispatch('getDefinitions').then(() => {
            this._loadTemplates();
        })
    }

    _updateActions() {
        this.navService.overrideMainSideNavActions([]);
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('rsvps', 'states').then((result) => {
            this.rsvpStates = result;
        })
    }

    _loadTemplates() {
        return this.templatesStore.dispatch('getData').then(() => {
            this.rawTemplates = this.templatesStore.state.data;
            this._prepareAvailableTemplateStates();
            this._updateActions();

            this.loading = false;
        });
    }

    _prepareAvailableTemplateStates() {
        this.availableTemplateStates = Object.keys(this.rsvpStates)
            .filter((status) => {
                return this.rawTemplates
                    .filter((glTemplate) => {
                        return glTemplate.status === status;
                    }).length === 0;
            });
    }
}

AlGuestlistTemplatesController.$inject = [
    '$injector',
    '$scope'
];



// WEBPACK FOOTER //
// ./src/app/modules/guestlists/components/al-guestlist-templates/controller.js